module.exports = __webpack_public_path__ + "static/zircon-star-hoop-earrings-2a2d1836008df2a36503122c7e4a2095.jpg";